import { useTheme } from "../../components/context/context"
import { Box, Container, Grid, Typography } from "@mui/material";
import KeyContacts from "./KeyContacts";
import WhatsNew from "./WhatsNew";
import useWindowSize from "../../components/windowSize/useWindowSize";
import Mcsppsa from "./Mcppssa";
import RelatedWebsites from "./RelatedWebsites";
import Download from "../../components/pdf_downloader/Downloader";

export default function Home() {
    const { fontSize } = useTheme();
    const windowSize = useWindowSize();
    const style = {
        homeContainer: {
            margin: "0 1rem"
        },
        header: {
            color: "#0b4285"
        }
    }
    return (
        <div style={style.homeContainer}>
            <Box sx={{ fontSize: `${fontSize + 0.2}rem` }}>
                <div>
                    <Grid container gap={0} sx={{ display: "flex", justifyContent: `${windowSize > 900 ? 'space-between' : "center"}` }}>
                        <Grid xs={12} md={9}>

                            <div>

                                <h2 style={style.header}>
                                    Meghalaya Society for Social Audit & Transparency
                                </h2>
                                <p style={{textAlign:"justify"}}>
                                    As per the guidelines of the Mahatma Gandhi National Rural Employment Gaurantee Act,
                                    2013 the Government of Meghalaya has established an independent organization,
                                    "Social Audit Unit" (SAU) in the name - Meghalaya Society for Social Audit & Transparency (MSSAT).
                                    The society is registered under the Meghalaya Society Registration Act XII of 1860. The basic purpose
                                    of forming this society is to facilitate the conduct of Social Audit at the Village level, so as to ensure
                                    Transparency & Accountability.
                                </p>
                            </div>
                            <br />
                            <Grid container gap={2} sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Grid xs={12} sm={12} md={12}>
                                    <WhatsNew />
                                </Grid>
                                <Grid xs={12} sm={12} md={12}>
                                    <Mcsppsa />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid xs={windowSize < 600 ? 12 : 5} md={2.8}>
                            <div>
                                <KeyContacts />
                            </div>

                        </Grid>
                    </Grid>
                </div>
            </Box>




        </div>
    )
}